import { ReactNode, useCallback, useState } from "react";
import { NavLink } from "react-router";
import t from "@/lang/lang";
import {
  SampleBaseDataTableFilters,
  useDefaultSampleBaseDataListRequest,
} from "@/services/backend/samples/components/sample-base-data-table";
import { SurfaceMicrobialBaseDataTable } from "@/services/backend/samples/components/surface-microbial-base-data-table";
import { CreateSurfaceMicrobialBaseDataDialog } from "@/services/backend/samples/components/create-surface-microbial-base-data-dialog";
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";

export function SurfaceMicrobialBaseDataListRoute() {
  const [request, setRequest] = useState(useDefaultSampleBaseDataListRequest());

  const renderRowLink = useCallback(
    (baseDataId: string, children: ReactNode) => (
      <NavLink to={baseDataId}>{children}</NavLink>
    ),
    [],
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Oberflächenkeimproben")}</CardTitle>
        <CardDescription>
          {t(
            "Hier können Sie die Vorgabewerte verwalten, mit denen eine neue Oberflächenkeimprobe angelegt wird. Die als aktiv markierten Basisdaten werden dafür verwendet.",
          )}
        </CardDescription>
        <CardAction>
          <CreateSurfaceMicrobialBaseDataDialog />
        </CardAction>
      </CardHeader>
      <CardContent className="grid gap-2">
        <SampleBaseDataTableFilters
          request={request}
          onRequestChange={setRequest}
        />
        <SurfaceMicrobialBaseDataTable
          request={request}
          onRequestChange={setRequest}
          renderRowLink={renderRowLink}
          hideBorder
        />
      </CardContent>
    </Card>
  );
}
